import { Stack, Tab, Tabs, Typography } from '@mui/material';
import {
  createFileRoute,
  Outlet,
  redirect,
  useLocation,
  useNavigate
} from '@tanstack/react-router';

const Layout = () => {
  const location = useLocation();
  const navigate = useNavigate({ from: Route.fullPath });

  const isTabbedRoute =
    location.pathname === '/queues' ||
    location.pathname === '/queues/' ||
    location.pathname === '/queues/settings' ||
    location.pathname === '/queues/settings/';

  if (!isTabbedRoute) {
    return <Outlet />;
  }

  const tab = location.pathname.startsWith('/queues/settings')
    ? 'settings'
    : 'queues';

  const onQueuesTab = () => navigate({ to: '/queues' });
  const onSettingsTab = () => navigate({ to: '/queues/settings' });

  return (
    <Stack spacing={2} sx={{ height: '100%', p: 2 }}>
      <Typography variant='h5'>SQS Queues</Typography>

      <Tabs value={tab}>
        <Tab
          data-testid='queuesTab'
          label='Queues'
          onClick={onQueuesTab}
          value='queues'
        />
        <Tab
          data-testid='queuesSettingsTab'
          label='Settings'
          onClick={onSettingsTab}
          value='settings'
        />
      </Tabs>

      <Outlet />
    </Stack>
  );
};

export const Route = createFileRoute('/queues')({
  beforeLoad: () => {
    if (localStorage.getItem('isAdmin') !== '1') {
      throw redirect({ to: '/organizations' });
    }
  },
  component: Layout
});
